import {
  updateCurrentContext
} from "./chunk-FCWOJULD.mjs";

// src/listeners/language-change-listener/language-change-listener.ts
function languageChangeListener() {
  const observer = new MutationObserver((mutationList) => {
    if (window.yvaDatastore && window.yvaDatastore.currentContextId) {
      mutationList.forEach((mutation) => {
        const htmlElement = mutation.target;
        if (mutation.oldValue !== htmlElement.lang) {
          updateCurrentContext({ device: { primary_locale: htmlElement.lang } });
        }
      });
    }
  });
  observer.observe(document.documentElement, {
    attributeFilter: ["lang"],
    attributeOldValue: true,
    childList: false
  });
  return () => observer.disconnect();
}

export {
  languageChangeListener
};
